module.exports = __webpack_public_path__ + "media/assets/community_index/grid-view-icon-4e8d82660e07cf981cfb9daca06ddb6fbb6b335fa2a99677616ffa253447824d.png";